<template>
  <v-container class="ma-0 pa-0">
    <v-card flat class="fill-height" width="100%">
      <h1 v-if="loGet(selectedApplication, 'firstName')">
        {{ $t('application.thanks.title') }} {{ selectedApplication.firstName }}!
      </h1>
      <p>{{ $t('application.thanks.info1') }}</p>

      <MessageBox class="mt-3" type="info">
        <h6 class="pb-4 title text-uppercase">{{ $t('application.thanks.boxTitle') }}</h6>
        <p>{{ $t('application.thanks.boxInfo') }}</p>
        <p>{{ $t('application.thanks.info2') }}</p>
        <p>
          <a :href="links.application.thankYou" target="_blank">{{ $t('application.thanks.info3') }}</a>
        </p>
      </MessageBox>
    </v-card>

    <NextButton @click="goHome" class="mt-8 mb-8">{{ $t('application.thanks.close') }}</NextButton>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import MessageBox from '@/components/Common/MessageBox'
import NextButton from '@/components/Common/NextButton'

// @group Application-Apprentice
// ApplicationThanks component
export default {
  name: 'ApplicationThanks',
  data() {
    return {
      links: require('../../../lib/external-links.json')
    }
  },
  components: {
    MessageBox,
    NextButton
  },

  computed: {
    ...mapGetters('application', ['currentStep', 'selectedApplication'])
  },
  methods: {
    ...mapActions('application', ['setSelectedApplication']),
    /**
     * @vuese
     * Used to push user to home page after application is all submited and update the application with an empty one
     */
    goHome() {
      this.setSelectedApplication({})
      this.$router.push('/').catch(() => {})
    }
  }
}
</script>